<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="edi-guide-dialog"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BootHelperPage')"
    :close-on-click-modal="false"
    :modal="false"
    :before-close="onCancel"
  >
    <div class="main-content">
      <div :class="'tabs-container'">
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <div class="operations" style="margin-bottom: 5px;margin-top: 5px">
            <div class="triggers">
              <div v-show="action==='look'" class="btn-group-look">
                <el-button no="edit" :disabled="!(currentRow && Number(currentRow.jobState) === 0 && !JobUtils.isBlockJob(currentRow))" type="success" @click="triggerEditEvent">{{ $t('common.btn.edit') }}</el-button>
                <el-button no="sendEdi" type="primary" @click="sendEdi">{{ $t('CargoMsg.Cargo_Send') }}</el-button>
                <el-button no="showEdi" type="primary" @click="showEdi">{{ $t('CargoMsg.Cargo_ViewingMessage') }}</el-button>
                <el-button no="close" @click="onCancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
              </div>
              <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                <el-button no="save" type="success" :disabled="isLoadingData" @click="triggerSaveEvent">{{ $t('common.btn.save') }}</el-button>
                <el-button no="cancel" type="success" @click="cancelEdit(()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
              </div>
            </div>
          </div>
          <el-tab-pane name="ediBaseWindow" :label="$t('SeaExport.Booking')">
            <edi-base-window ref="ediBaseWindow" :context="context" :action="action" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ediBaseWindow from '@/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediBaseWindow'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  catchErrorTip
} from '@/utils/commonUtil'
import lodash from 'lodash'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getEDI, getFtpEDI, getLastEdiRecord, uploadEdiFile } from '@/api/seaExport/edi'
import * as EdiSendType from '@/class/cargo/model/parameters/EdiSendType'
import { parseTime } from '@/utils/index.js'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'

export default {
  name: 'EdiGuideWindow',
  components: {
    ediBaseWindow
  },
  props: {
    context: { type: Object, required: true },
    visible: { type: Boolean, required: true },
    doSaving: { type: Boolean, default: false },
    globalVar: { type: Object, required: true },
    callBackFunc: { type: Function, required: false }
  },
  data() {
    return {
      loading: false,
      showButton: false,
      action: 'look',
      currentRow: {},
      params: {},
      uploadEdiFileVo: {
        fileName: '',
        content: ''
      },
      JobUtils,
      SystemConstants,
      isLoadingData: false, // 是否正在加载数据
      editEventFlag: false, // 编辑事件标识
      activeTabName: 'ediBaseWindow',
      labState: '',
      defaultFileType: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.editHandler('edit')
        })
      }
    },
    doSaving(newVal) {
      if (newVal) {
        this.loading = getLoading4Cxt(this)
      } else {
        if (this.loading) {
          this.action = 'look'
          this.loading.close()
        }
      }
    }
  },
  methods: {
    async showDetail(job) {
      this.currentRow = job
      job.ediSave = false
      this.nowGlobalVar = lodash.cloneDeep(this.globalVar)
      this.handleTabClick()
    },
    onCancel() {
      if (this.action === 'edit') {
        this.$message.warning(this.$t('Message.PleaseExitTheEditingModule'))
        return
      }
      this.$emit('close')
    },
    triggerEditEvent() {
      this.editEventFlag = true
    },
    sendEdi() {
      const self = this
      const param = {}
      param.ediType = self.nowGlobalVar.ediType
      param.templateId = self.nowGlobalVar.ediTemplate.uuid
      param.jobUuids = self.nowGlobalVar.ediTemplateWin.uuids
      param.editStatus = self.nowGlobalVar.editStatus
      param.ruleEDINos = []
      self.loading = getLoading4Cxt()
      getEDI(param).then(result => {
        self.loading.close()
        this.onSuccess(result)
      }).catch(message => {
        this.onExportEDIFail(message)
      }).finally(() => {
        if (self.loading) {
          self.loading.close()
        }
      })
    },
    // edi导出失败回调方法
    async onExportEDIFail(dataMsg) {
      if (dataMsg instanceof Error) {
        return
      }
      const modelMap = ModelMap['ProperyLabelMap']
      const errorMsgArr = dataMsg ? dataMsg.split(';') : null
      let finalMessage = ''
      const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
      if (errorMsgArr && errorMsgArr.length > 0) {
        errorMsgArr.forEach(errorMsg => {
          const modelField = errorMsg.split('.')
          if (modelField && modelField.length > 0) {
            const model = modelMap[modelField[0]]
            if (model) {
              finalMessage += (model[modelField[1]] + suffixMsg)
            }
          } else {
            finalMessage += errorMsg
          }
        })
      }
      if (finalMessage) {
        this.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
      } else {
        this.$message.error({ dangerouslyUseHTMLString: true, message: dataMsg })
      }
    },
    async onSuccess(response) {
      const self = this

      if (!response || !response.data || JSON.stringify(response.data) === '{}') {
        self.$message.info(this.$t('SeaExport.NoImportEDI'))
        return
      }
      const result = response.data
      const sendVersion = JSON.parse(result.sendVersion)
      self.globalVar.sendVersion = sendVersion[self.globalVar.selectedJob.uuid]
      delete result.sendVersion
      self.globalVar.ediDatas = result
      this.params = {
        job: self.globalVar.selectedJob,
        title: self.globalVar.title,
        ediType: self.globalVar.ediType,
        ediCollection: self.globalVar.ediDatas,
        sendVersion: self.globalVar.sendVersion,
        ediStatus: self.globalVar.editStatus,
        ediTemplate: self.globalVar.ediTemplate,
        ediStatusName: self.globalVar.ediStatusName
      }
      // 判断最后一个记录是否是列队中
      const continueExec = await this.checkLastEdiState(this.params.job.uuid, this.params.ediType)
      if (!continueExec) {
        this.$message.warning(this.$t('SeaExport.HasBillExist', [this.params.job.jobNo]))
        return
      }

      const ediDatas = response.data
      const tabs = []
      for (const key in ediDatas) {
        if (key === 'ediTextManifestInfoUUIDs' || key === 'sendVersion') {
          continue
        }
        if (key === 'defaultFileType') {
          this.defaultFileType = ediDatas['defaultFileType']
        }
        if (key !== 'encode') {
          tabs.push({
            id: key,
            name: key,
            content: ediDatas[key]
          })
        }
      }
      await this.$confirm(this.$t('SeaExport.UploadEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'info' })
      const content = tabs[0].content
      this.uploadEdiFileVo.fileName = this.$t('SeaExport.Send')
      this.uploadEdiFileVo.content = content
      const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
      const sendFilePrefix = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendFilePrefix
      const ediObj = {}
      ediObj['templatePath'] = !this.params.ediTemplate ? '' : this.params.ediTemplate.templatePath
      ediObj[tabs[0].id] = content
      if (this.params.ediCollection) {
        ediObj['ediTextManifestInfoUUIDs'] = this.params.ediCollection['ediTextManifestInfoUUIDs']
      }
      if (this.params.manifestInfo && this.params.manifestInfo.uuid && (this.params.ediType === 26)) {
        ediObj.manifestInfoKey = this.params.manifestInfo.uuid
      }
      let ediSendType = 0
      if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
        ediSendType = EdiSendType.EDI_ORIGINAL_FTP_SEND.code
      } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
        ediSendType = EdiSendType.EDI_UPDATE_FTP_SEND.code
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediObj,
        sendType: sendType,
        sendFilePrefix: sendFilePrefix,
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : '',
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        ediSendType: ediSendType,
        uploadFileVo: JobUtils.assemblyParametersForUploadFileOfSendEdi(this.params, this.defaultFileType, 2, content)
      }
      self.loading = getLoading4Cxt()
      getFtpEDI(data).then(result => this.onFtpEDISuccess(result, data)).finally(() => { self.loading.close() })
    },
    onFtpEDISuccess(result, data) {
      if ((this.params.ediType === EdiType.BOOKING_EDI_TYPE.code || this.params.ediType === EdiType.BILL_EDI_TYPE.code) && result.data && !result.data.isSuccess) {
        this.$confirm(this.$t('SeaExport.CurrentNetworkChannelUnstable'), this.$t('SeaExport.EdiTips'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          data.retrySize = 1
          getFtpEDI(data).then(res => { })
        }).catch((e) => {
          this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
        })
        return
      } else if (result.data && result.data.uploadResult) {
        this.$message.info(this.$t('SeaExport.UploadEDISucceeded'))
        this.$emit('uploadSuccess', true)
        return
      }
      this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
    },
    /**
     * 判断最后一个记录是否是列队中
     * @returns
     */
    async checkLastEdiState(jobUuid, ediType) {
      let contnueExec = true
      if ((ediType === EdiType.BOOKING_EDI_TYPE.code || ediType === EdiType.BILL_EDI_TYPE.code)) {
        const loading = getLoading4Cxt()
        await getLastEdiRecord({ jobUuid: jobUuid, type: ediType }).then(res => {
          if (res.data && res.data.bookingState && (res.data.bookingState === SystemConstants.JOB_BOOKING_IN_QUEUE.code || res.data.bookingState === SystemConstants.JOB_BILL_IN_QUEUE.code)) {
            contnueExec = false
          }
        }).finally(() => loading.close())
      }
      return contnueExec
    },
    // 上传文件至云存储
    // button 0 默认未知, 1 导出本页EDI,2 上传本页EDI, 3 上传所有EDI, 4 邮件上传EDI
    uploadFileToStorage(button = 0, originalFile = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')) {
      const uploadEdiFileVo = this.uploadEdiFileVo
      if (!this.uploadEdiFileVo.content) return
      const ediType = this.params.ediType
      if (ediType > 0 && [1, 2, 3, 4, 6, 7, 8, 11, 15, 30, 23, 26, 27, 43].includes(ediType)) {
        let documentType = ''
        switch (ediType) {
          case 1 : // 订舱
            documentType = 'BOOKING_EDI'
            break
          case 2 : // 提单
            documentType = 'LADING_BILL_EDI'
            break
          case 4 : // 安装箱
            documentType = 'INSTALL_EDI'
            break
          case 6 : // 预配舱单
            documentType = 'PRECONFIGURE_SHIPPING_EDI'
            break
          case 7 : // 清洁舱单
            documentType = 'IFCSUM_EDI'
            break
          case 8 : // 反恐舱单
            documentType = 'JP24SMF_EDI'
            break
          case 11 : // VGM
            documentType = 'VGM_EDI'
            break
          case 3 : // 海外代理预报
          case 15 : // 海外代理预报(包括CargoWise和荆艺接口)
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          case 30 : // 提箱
            documentType = 'SUITCASE_TYPE_EDI'
            break
          case 23 : // VGM
            documentType = 'VGM2_MANIFESTINFO_EDI'
            break
          case 26 : // 预配舱单-MANIFESTINFO方式
            documentType = 'PRECONFIGURE_MANIFESTINFO_SHIPPING_EDI'
            break
          case 27 : // 清洁舱单-MANIFESTINFO方式
            documentType = 'IFCSUM_MANIFESTINFO_EDI'
            break
          case 43 : // JCL预报
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          default:
            return null
        }
        if (documentType) {
          const params = {}
          params.fileType = this.getExportFileFix()
          params.createdBy = String(this.$store.getters.userInfo.userId)
          const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
          const sendTypeItem = ChargeItemTarget.getChargeItemTargetByCode2(sendType)
          params.fileSource = (sendTypeItem && sendTypeItem.code) ? sendTypeItem.code : ''
          params.documentType = documentType
          // 文件名
          if (this.params.hasOwnProperty('ediStatusName') && this.params.ediStatusName) {
            uploadEdiFileVo.fileName = this.getButtonName(button) + this.params.ediStatusName + '_' + originalFile + this.getExportFileFix()
          } else {
            uploadEdiFileVo.fileName = uploadEdiFileVo.fileName + this.getExportFileFix()
          }
          params.uuid = encodeURIComponent(this.params.job.uuid)
          params.jobNo = this.params.job.jobNo
          uploadEdiFileVo.params = params
          uploadEdiFile(uploadEdiFileVo).then().catch()
        }
      }
    },
    showEdi() {
      this.callBackFunc(this.globalVar.ediTemplate)
    },
    // 编辑
    async editHandler(action) {
      if (this.currentRow.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(this.currentRow, false)) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      // 延迟执行，避免阻塞页面渲染
      setTimeout(async() => {
        await this.againShow(action)
      }, 5)
    },
    // 合并数据
    async againShow(action) {
      this.action = action
      const job = this.currentRow
      const jobModel = new SeaExportJob(job)
      if (job.uuid) {
        job.version = 0 // version为0时可以重新加载job
        job.charges = ''
        job.seaCargoDoc = ''
        job.jointSlavesHBL = ''
        this.isLoadingData = true
        try {
          await jobModel.loadJobRelated({
            job: !(jobModel.version >= 1), // 脏数据，需要重新载入
            seaEQ: true,
            lclSlaves: job.masterFlag,
            charges: true,
            warehouseIn: true,
            warehouseInfo: true,
            trucking: true,
            dischargingTrucking: true,
            lclMaster: !job.masterFlag,
            seaCargoDoc: true,
            containerUsages: true,
            containers: true,
            cargoBulkDetail: !job.masterFlag,
            surchargeTerms: !job.masterFlag || (ContainerLoadType.BC_CARGO_TYPE_FCL.code === job.containerLoadType && job.masterFlag),
            backUpWarehouseInfo: true,
            manifestInfos: true,
            fbaJob: job.fba, // fba业务就加载
            orderCenterMode: this.useOrderCenterMode,
            cooperateBranchId: this.cooperateBranchId,
            jobWarehouseNos: this.jingyuWarehouse // 开了参数的有需要加载多进仓编号列表
          })
          if (jobModel.dischargingPortDoor || jobModel.usCustomsClearance) {
            jobModel.destinationPortService = true
          }
        } finally {
          this.isLoadingData = false
        }
        // 过滤脏数据（seaEQ、containers、containerUsages）
        if (jobModel.lclMasterUuid && [ContainerLoadType.LCL_CARGO_TYPE.code, ContainerLoadType.BC_CARGO_TYPE.code].includes(jobModel.containerLoadType)) {
          if (jobModel.seaEQ) {
            jobModel.seaEQ = []
          }
          if (jobModel.containers) {
            jobModel.containers = []
          }
          if (jobModel.containerUsages) {
            jobModel.containerUsages = jobModel.containerUsages.filter(p => !p.container || p.container.jobUuid === jobModel.lclMasterUuid)
          }
        }
        // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
        if (!jobModel.masterFlag) {
          ContainerUtil.buildContainerUsages(job)
        }

        if (!job.path) {
          this.setBasicData(job)
        }
      }
      this.currentRow = job
      this.handleTabClick()
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_SE, true, this.currentRow ? this.currentRow.jobNo || '' : '')
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => {
      })
    },
    async triggerSaveEvent() {
      if (this.currentRow.transfering && (!this.currentRow.transferPortCode || !this.checkSeaport(this.currentRow.transferPortCode))) {
        this.$message.warning(this.$t('Message.IfThereIsATransferTheTransferPortCannotBeNull'))
        return
      }
      this.currentRow.ediSave = true
      this.$refs.ediBaseWindow.fillModel()
      this.$emit('ediChangeHandler')
    },
    checkSeaport(code) {
      const obj = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', code)
      return Boolean(obj)
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow)
      })
    },
    getExportFileFix() {
      const ediTemplate = this.params.ediTemplate
      if (!ediTemplate || !ediTemplate.defaultFileType) {
        return this.defaultFileType ? this.defaultFileType : '.data'
      }
      return ediTemplate.defaultFileType
    }
  }
}
</script>

<style lang="scss">
.el-dialog.edi-guide-dialog {
  display: flex;
  height: 750px;
  width: 1085px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .el-dialog__body {
    height: 100%;
  }
}
</style>
